export default __webpack_public_path__ + "static/media/king-shark.3aa4a585.png";